export const DESIGNPARAMETER_UPDATE_ACTION_SUCCESS = 'DESIGNPARAMETER_UPDATE_ACTION_SUCCESS';
export const DESIGNPARAMETER_RESET_STATE = 'DESIGNPARAMETER_RESET_STATE';
export const DESIGNPARAMETER_UPDATE_SAVED_STATE = 'DESIGNPARAMETER_UPDATE_SAVED_STATE';
export const DESIGNPARAMETER_UPDATE_EXISTING_STATE = 'DESIGNPARAMETER_UPDATE_EXISTING_STATE'
export function updateDesignParameter(data) {
  return {
    type: DESIGNPARAMETER_UPDATE_ACTION_SUCCESS,
    data,
  };
}

export function resetDesignParameterState() {
  return {
    type: DESIGNPARAMETER_RESET_STATE,
  };
}

/**
 * Update state of current design state
 * @param {Boolean} isUpdated has introduced new unchages changes
 */
export function updateDesignSavedState(isUpdated) {
  return {
    type: DESIGNPARAMETER_UPDATE_SAVED_STATE,
    data: { isUpdated },
  };
}

/**
 * Update state of current design's existance
 * @param {Boolean} isExisting has introduced new unchages changes
 */
export function updateDesignExistingState(isExisting) {
  return {
    type: DESIGNPARAMETER_UPDATE_EXISTING_STATE,
    data: { isExisting },
  };
}
